/**
 * Identity key for a loaded permission set (see IAuthContext.permissionsLoadedFor): which user at
 * which institution the effective keys were fetched for. Kept outside AuthContext so consumers
 * (and tests that auto-mock the context module) get the real function.
 */
export const permissionsKey = (username: string | null | undefined, institutionId: string | null | undefined) =>
    `${username ?? ''}|${institutionId ?? ''}`;
